import type { BadgeVariant } from '@/components/ui/badge';

export const TRANSIT_STATUS_VARIANTS: Partial<Record<number, BadgeVariant>> = {
  0: 'gray',
  1: 'gray',
  12: 'blue',
  14: 'blue',
  15: 'green',
  16: 'gray',
  21: 'destructive',
  27: 'orange',
};
